import React, { useRef, useEffect, useState } from "react";
import { banner, images, internationalBanner } from "../../Config/images";
import CommonBreadcrumbs from "../../componant/Breadcrumb/Breadcrumb";
import HomeBooking from "../../componant/HomeBooking/HomeBooking";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  Box,
  Container,
  Paper,
} from "@mui/material";
import "./InternationalPatient.css";
import {
  getAdditionalSupport,
  getComprehensiveCare,
  getMedicalJourney,
  getSpecialties,
} from "../../Services/services";
import { useNavigate } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";



// Material-UI Icons
import CalendarCheckIcon from "@mui/icons-material/EventAvailable"; // Equivalent to CalendarCheck
import ShieldCheckIcon from "@mui/icons-material/Security"; // Equivalent to ShieldCheck
import FileTextIcon from "@mui/icons-material/Description"; // Equivalent to FileText
import StethoscopeIcon from "@mui/icons-material/MedicalServices"; // Equivalent to Stethoscope
import HandshakeIcon from "@mui/icons-material/Handshake"; // Equivalent to Handshake


// Alider Arrow
const PrevArrow = ({ onClick }) => (
  <div className="custom-arrow custom-prev" onClick={onClick}>
    <FaChevronLeft size={18} color="white"/>
  </div>
);

const NextArrow = ({ onClick }) => (
  <div className="custom-arrow custom-next" onClick={onClick}>
    <FaChevronRight size={18} color="white"/>
  </div>
);


const InternationalPatient = ({ headerData, footerData }) => {
  const [comprehensiveData, setComprehensiveData] = useState([]);
  const [medicalData, setMedicalData] = useState([]);
  const [supportServices, setSupportServices] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    handleGetComprehensiveData();
    handleGetMedicalData();
    handleAdditionalSupport();
  }, []);

  const handleGetComprehensiveData = async () => {
    try {
      const resp = await getComprehensiveCare();
      if (resp.status === 200) {
        setComprehensiveData(resp.data.responseBody);
        setLoading(false)
      }
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };
  const handleGetMedicalData = async () => {
    try {
      const resp = await getMedicalJourney();
      if (resp.status === 200) {
        setMedicalData(resp.data.responseBody);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };
  const handleAdditionalSupport = async () => {
    try {
      const resp = await getAdditionalSupport();
      if (resp.status === 200) {
        setSupportServices(resp.data.responseBody);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };
  const breadcrumbsData = [
    { label: "Home", url: "/" },
    { label: "International Patient", url: "/international-patient" },
  ];
  const topRef = useRef(null);

  const services = [
    {
      title: "Medical Coordination",
      description:
        "Dedicated team for appointment scheduling and treatment planning",
      icon: internationalBanner.medicalCoordination,
    },
    {
      title: "Language Support",
      description: "Multi-lingual interpreters for seamless communication",
      icon: internationalBanner.language,
    },
    {
      title: "Travel Arrangements",
      description: "Airport pickup/drop and local transportation assistance",
      icon: internationalBanner.travel,
    },
    {
      title: "Accommodation",
      description: "Comfortable stay options for patients and attendants",
      icon: internationalBanner.accommodation,
    },
    {
      title: "Insurance Support",
      description: "Assistance with insurance claims and documentation",
      icon: internationalBanner.insurance,
    },
  ];

  const journeySteps = [
    {
      step: "01",
      title: "Consultation & Assessment",
      description:
        "Your journey begins with a thorough consultation with our specialists, where we understand your medical history and current health concerns.",
      icon: <StethoscopeIcon sx={{ fontSize: 36, color: "#354895" }} />, // Using Material-UI sx prop for color
    },
    {
      step: "02",
      title: "Diagnosis & Planning",
      description:
        "Based on the assessment, we conduct necessary diagnostic tests to accurately identify your condition and create a personalized treatment plan.",
      icon: <FileTextIcon sx={{ fontSize: 36, color: "#16a34a" }} />,
    },
    {
      step: "03",
      title: "Treatment Execution",
      description:
        "We initiate your tailored treatment plan, utilizing advanced medical techniques and compassionate care to guide you towards recovery.",
      icon: <ShieldCheckIcon sx={{ fontSize: 36, color: "#7e22ce" }} />,
    },
    {
      step: "04",
      title: "Recovery & Follow-up",
      description:
        "Post-treatment, we monitor your recovery closely with regular follow-ups and provide guidance for maintaining your long-term health.",
      icon: <CalendarCheckIcon sx={{ fontSize: 36, color: "#ea580c" }} />,
    },
    {
      step: "05",
      title: "Continued Support",
      description:
        "Our commitment extends beyond treatment, offering ongoing support and resources to ensure your continued well-being and health management.",
      icon: <HandshakeIcon sx={{ fontSize: 36, color: "#dc2626" }} />,
    },
  ];

  const [specialties, setSpecialties] = useState([]);

  // Add this effect to fetch specialties
  useEffect(() => {
    getSpecialtiesDetails();
  }, []);

const settings = {
  // centerMode: true,
  infinite: specialties.length > 3,
  speed: 500,
  dots: false,
  slidesToShow: 12,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2500,
  arrows: true,
  prevArrow: <PrevArrow />,
  nextArrow: <NextArrow />,
  responsive: [
    { breakpoint: 2800, settings: { slidesToShow: 12 } },
    { breakpoint: 2600, settings: { slidesToShow: 11 } },
    { breakpoint: 2400, settings: { slidesToShow: 10 } },
    { breakpoint: 2200, settings: { slidesToShow: 9 } },
    { breakpoint: 2000, settings: { slidesToShow: 8 } },
    { breakpoint: 1800, settings: { slidesToShow: 7 } },
    { breakpoint: 1600, settings: { slidesToShow: 6 } },
    { breakpoint: 1400, settings: { slidesToShow: 5 } },
    { breakpoint: 1200, settings: { slidesToShow: 4 } },
    { breakpoint: 992, settings: { slidesToShow: 3 } },
    { breakpoint: 768, settings: { slidesToShow: 3 } },
    { breakpoint: 700, settings: { slidesToShow: 2 } },
    { breakpoint: 600, settings: { slidesToShow: 2 } },
    { breakpoint: 500, settings: { slidesToShow: 2 } },
    { breakpoint: 480, settings: { slidesToShow: 1 } },
    { breakpoint: 400, settings: { slidesToShow: 1 } },
  ],
};





  const getSpecialtiesDetails = async () => {
    try {
      const resp = await getSpecialties();
      if (resp.status === 200) {
        setSpecialties(resp.data.responseBody);
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  const navigate = useNavigate();
  const theme = createTheme({
    palette: {
      mode: "light", // Default to light mode
      primary: {
        main: "#354895", // A shade of blue
      },
      secondary: {
        main: "#ef4444", // A shade of red for emphasis
      },
      background: {
        default: "#f9fafb", // Light gray background
        paper: "#ffffff", // White paper background
      },
      text: {
        primary: "#111827", // Dark gray text
        secondary: "#4b5563", // Medium gray text
      },
    },
    typography: {
      fontFamily: "Inter, sans-serif",
      h2: {
        fontWeight: 800,
        fontSize: "3rem",
        "@media (min-width:600px)": {
          fontSize: "4rem",
        },
        lineHeight: 1.2,
      },
      h3: {
        fontWeight: 700,
        fontSize: "1.75rem",
        lineHeight: 1.3,
      },
      body1: {
        fontSize: "1rem",
        lineHeight: 1.6,
      },
    },
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            borderRadius: 24, // Rounded corners for cards
            transition: "all 0.3s ease-in-out",
            "&:hover": {
              transform: "translateY(-8px)", // Hover effect
              boxShadow:
                "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)", // Hover shadow
            },
          },
        },
      },
      MuiContainer: {
        styleOverrides: {
          // Access theme directly within the styleOverrides callback
          root: ({ theme }) => ({
            paddingTop: theme.spacing(6),
            paddingBottom: theme.spacing(6),
          }),
        },
      },
    },
  });
  const ShimmerCard = () => (
    <div className="service-grid-item">
      <Card
        className="service-card h-full flex flex-col justify-between shadow-lg rounded-lg animate-pulse"
        style={{ borderRadius: "12px" }}
      >
        <CardContent className="flex flex-col items-center p-6">
          <div className="service-icon mb-4 bg-gray-300 rounded-full w-16 h-16"></div> {/* Shimmer for image */}
          <div className="service-title bg-gray-300 h-6 w-3/4 mb-2 rounded"></div> {/* Shimmer for title */}
          <div className="service-description bg-gray-300 h-4 w-full rounded"></div> {/* Shimmer for subtitle line 1 */}
          <div className="service-description bg-gray-300 h-4 w-5/6 rounded mt-1"></div> {/* Shimmer for subtitle line 2 */}
        </CardContent>
      </Card>
    </div>
  );
  const ShimmerJourneyStep = () => (
    <div className="journey-step animate-pulse">
      <div className="step-number bg-gray-300 rounded-full w-12 h-12 mb-2"></div> {/* Shimmer for step number */}
      <div className="step-title bg-gray-300 h-6 w-3/4 mb-2 rounded"></div> {/* Shimmer for title */}
      <div className="step-description bg-gray-300 h-4 w-full rounded"></div> {/* Shimmer for subtitle line 1 */}
      <div className="step-description bg-gray-300 h-4 w-5/6 rounded mt-1"></div> {/* Shimmer for subtitle line 2 */}
    </div>
  );
  const ShimmerSpecialtyCard = () => (
    <Box
      className="specialty-card-marquee specialties-box animate-pulse"
      sx={{ cursor: "default" }} // Remove pointer cursor for shimmer
    >
      <div className="special-image bg-gray-300 rounded-lg w-24 h-24 sm:w-28 sm:h-28 md:w-32 md:h-32 mx-auto mb-3"></div> {/* Shimmer for image */}
      <Typography
        variant="h6"
        className="specialty-heading bg-gray-300 h-6 w-5/6 mx-auto rounded mb-2"
        sx={{
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxHeight: "200px", // Retain for layout consistency
        }}
      ></Typography>
      <Typography
        className="bg-gray-300 h-4 w-4/5 mx-auto rounded" // Shimmer for second line of title
      ></Typography>
    </Box>
  );
  const shimmerCardCount = 6;
  return (
    <>
      <div className="content-image" ref={topRef}>
        <div className="image-container">
          <img
            className="background-image"
            src={banner.aboutUSNewBanner}
            alt="Banner"
          />
          <div className="text-container">
            <h1 className="text-title">International Patient Care</h1>
            <p className="text-paragraph">
              World-Class Healthcare <br />
              With Global Standards
            </p>
            <div className="breadcrumb">
              <CommonBreadcrumbs items={breadcrumbsData} separator="›" />
            </div>
          </div>
        </div>
      </div>

      <HomeBooking noMargin footerData={footerData} />

      <div className="international-patient-section mb-8 mt-5">
        {/* Services Section */}
        <div className="international-patient-services-section mt-8 mb-8">
          <div className="container mx-auto px-4">
            {" "}
            {/* Added a container for better centering and padding */}
            <h2 className="section-title text-center text-4xl font-bold mb-3 text-gray-800">
              International Patient Services
            </h2>
            <div className="mb-8">
              <p
                className="personalized-text text-center text-xl text-gray-600 max-w-2xl mx-auto"
                style={{ fontSize: "25px" }}
              >
                Comprehensive Care for International Patients
              </p>
            </div>
            <div className="service-grid-container grid gap-6 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
      {loading ? (
        // Render shimmer placeholders while loading
        Array.from({ length: 5 }).map((_, index) => ( // Render 3 shimmer cards as an example
          <ShimmerCard key={index} />
        ))
      ) : (
        // Render actual cards once data is loaded
        comprehensiveData.map((service, index) => (
          <div className="service-grid-item" key={index}>
            <Card
              className="service-card h-full flex flex-col justify-between shadow-lg hover:shadow-xl transition-shadow duration-300 rounded-lg"
              style={{ borderRadius: "12px", padding:"10px" }}
            >
           
                <div className="service-icon mb-3">
                  <img
                    src={service.image}
                    alt={service.title}
                   
                  />
                </div>
                <Typography
                  variant="h5"
                  component="h3"
                  className="service-title text-center font-semibold mb-2 text-gray-700"
                >
                  {service.title}
                </Typography>
                <Typography
                  variant="body1"
                  className="service-description text-center text-gray-500"
                >
                  {service.subtitle}
                </Typography>
          
            </Card>
          </div>
        ))
      )}
    </div>
          </div>
        </div>

        {/* Patient Journey Section */}
        <div className="patient-journey-section">
      <h2 className="section-title text-center">Your Medical Journey</h2>
      <Box className="journey-steps-container">
        {loading ? (
          // Render shimmer placeholders while loading
          // Adjust the number of shimmer steps based on your typical data
          Array.from({ length: 4 }).map((_, index) => (
            <ShimmerJourneyStep key={index} />
          ))
        ) : (
          // Render actual journey steps once data is loaded
          medicalData.map((step, index) => (
            <div className="journey-step" key={index}>
              <div className="step-number">{step.id}</div>
              <Typography variant="h3" className="step-title">
                {step.title}
              </Typography>
              <Typography variant="body1" className="step-description">
                {step.subtitle}
              </Typography>
            </div>
          ))
        )}
      </Box>
    </div>

        {/* Replace both specialties sections with this single section */}
        <div className="full-width-specialties">
      <h2 className="section-title text-center mb-2">
        Our Medical Expertise
      </h2>
      <div className="mb-4">
        <p
          className="personalized-text text-center"
          style={{ color: "#333333", fontSize: "22px" }}
        >
          World-Class Specialties for International Patients
        </p>
      </div>

      {/* Slick Slider for specialties */}
      <div className="specialties-slider-wrapper">
        <Slider {...settings}>
          {loading
            ? Array.from({ length: shimmerCardCount }).map((_, index) => (
                <div key={index}>
                  <ShimmerSpecialtyCard />
                </div>
              ))
            : specialties.map((specialty, index) => (
                <div key={index}>
                  <Box
                    className="specialty-card-marquee specialties-box"
                    onClick={() => navigate(`/health-specialist/${specialty.id}`)}
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      src={specialty.image}
                      alt={specialty.name}
                      className="special-image"
                    />
                    <Typography
                      variant="h6"
                      className="specialty-heading"
                      sx={{
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {specialty.title}
                    </Typography>
                  </Box>
                </div>
              ))}
        </Slider>
      </div>

    </div>

        {/* Support Services */}
        <div className="support-services-section mt-5 mb-5">
          <Container>
            <Grid container spacing={1}>
              <Grid item xs={12} md={6}>
                <div className="support-content">
                  <h2 className="section-title">Additional Support Services</h2>
                  <ul className="support-list">
                    {supportServices.map((e) => {
                      return <li key={e.id}>{e.title}</li>;
                    })}
                  </ul>
                  <Button
                    variant="contained"
                    className="book-appointment-btn"
                    onClick={() => navigate("/doctor-list")}
                  >
                    Book an Appointment
                  </Button>
                </div>
              </Grid>
              <Grid item xs={12} md={6}>
                <div className="contact-info-box">
                  <div className="contact-header">
                    <h3>Contact International Patient Care</h3>
                    <div className="contact-badge">24/7 Support</div>
                  </div>
                  <div className="contact-details">
                    <div className="contact-item">
                      <div className="contact-icon">
                        <i className="fab fa-whatsapp"></i>
                      </div>
                      <div className="contact-text">
                        <label>WhatsApp</label>
                        <a
                          href={`https://wa.me/${headerData?.help_whatsapp?.replace(
                            /[^0-9]/g,
                            ""
                          )}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="contact-link"
                        >
                          {headerData?.help_whatsapp}
                        </a>
                      </div>
                    </div>
                    <div className="contact-item">
                      <div className="contact-icon">
                        <i className="far fa-envelope"></i>
                      </div>
                      <div className="contact-text">
                        <label>Email</label>
                        <a
                          href={`mailto:${footerData?.email}`}
                          className="contact-link"
                        >
                          {footerData?.email}
                        </a>
                      </div>
                    </div>
                    <div className="contact-cta">
                      <p className="availability">
                        Our team is available 24/7 to assist you
                      </p>
                      <Button
                        variant="contained"
                        className="contact-btn"
                        onClick={() => navigate("/contact")}
                      >
                        Get in Touch
                      </Button>
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Container>
        </div>
      </div>
    </>
  );
};

export default InternationalPatient;
